// extracted by css-extract-rspack-plugin
var _1 = "Q7_8q";
export { _1 as "spinner" }
